module.exports = __webpack_public_path__ + "img/guide.a338f9b3.jpg";